import { rem } from 'polished';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem('24px')};

  @media only screen and (max-width: ${rem('580px')}) {
    padding: ${rem('16px')};
  }
`;

export const VisualStackContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  height: ${rem('420px')};
  margin-top: ${rem('100px')};
  width: 100%;
  @media only screen and (max-width: ${rem('580px')}) {
    height: ${rem('335.04px')};
    width: 100%;
    margin-top: ${rem('32px')};
  }

  @media only screen and (min-width: ${rem('992px')}) {
    height: ${rem('483.55px')};
    width: 100%;
  }
`;

export const StyledH2Text = styled.h2`
  color: #000000;
  font-family: 'Nunito';
  font-weight: 700;
  font-size: ${rem('32px')};
  margin: 0;
  text-align: center;
  line-height: ${rem('40px')};
  padding: 0px ${rem('10px')};

  @media only screen and (max-width: ${rem('580px')}) {
    font-size: ${rem('18px')};
  }
`;

export const StyledH3Text = styled.h3`
  color: #000000;
  font-family: 'Nunito';
  font-weight: 300;
  margin: 0px ${rem('20px')};
  font-size: ${rem('20px')};
  text-align: center;
  line-height: ${rem('27.28px')};
  padding: 0px ${rem('10px')};

  @media only screen and (max-width: ${rem('580px')}) {
    font-size: ${rem('16px')};
    font-weight: 400;
    margin: 0px;
  }
`;
